import React from 'react';
import SvgIcon from '@material-ui/core/SvgIcon';

const Media = props => (
  <SvgIcon {...props} viewBox="0 0 32 32">
    <path d="M23.879 16.663c0.123-0.237 0.361-0.385 0.622-0.385 0.259 0 0.498 0.148 0.621 0.384l4.308 8.252c0.118 0.227 0.113 0.503-0.014 0.725s-0.359 0.358-0.608 0.358h-12.778l3.432-6c0.12-0.166 0.3-0.271 0.499-0.29 0.027-0.004 0.053-0.006 0.079-0.006 0.17 0 0.337 0.072 0.464 0.193l1.138 1.077 2.237-4.308zM19.439 14.421c0.618 0 1.12 0.509 1.12 1.136s-0.502 1.136-1.12 1.136c-0.618 0-1.12-0.509-1.12-1.136s0.502-1.136 1.12-1.136z" />
    <path d="M17.937 11.263h-2.158c-0.552 0-1 0.448-1 1v8.474h-10.579c-0.552 0-1-0.448-1-1v-12.737c0-0.552 0.448-1 1-1h12.737c0.552 0 1 0.448 1 1v4.263zM9.354 10.839c-0.37-0.254-0.891-0.005-0.891 0.427l0.001 4.206c0 0.43 0.518 0.68 0.888 0.428l3.088-2.092c0.31-0.211 0.311-0.644 0.002-0.855l-3.089-2.114z" />
  </SvgIcon>
);

export default Media;
